import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import Loading from './../Loading'
import i18next from 'i18next'

import * as accountActions from '../../ducks/account'
import AccountSetPassword from '../AccountSetPassword'

class AccountVerificationContainer extends React.Component {
  componentDidMount() {
    this.props.actions.getByVerificationToken(this.props.params.uuid)
  }

  render() {
    if (this.props.account === null && this.props.isAccountVerificationTokenValid === null) {
      return <Loading />
    }

    const onVerify = password =>
      this.props.actions.verify(this.props.params.uuid, this.props.account.email, password)

    return (
      <AccountSetPassword
        showAccount={true}
        account={this.props.account}
        isLinkValid={!!this.props.account}
        title={i18next.t('activate_your_account')}
        formDescription={i18next.t('activate_account_description')}
        buttonText={i18next.t('verify')}
        onSetPassword={onVerify}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    account: state.account.get('accountWaitingForVerification'),
    isAccountVerificationTokenValid: state.account.get('isAccountVerificationTokenValid')
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(accountActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountVerificationContainer)



// WEBPACK FOOTER //
// ./src/components/smart/AccountVerificationContainer.js